import React, { useState, useEffect } from "react";
import "./cbm.css";
import Select from "react-select";
import axios from "axios";

function Cbm(props) {
  return (
    <>
      <h3>Condition Based Monitoring</h3>
    </>
  );
}

export default Cbm;
